import { Secret } from "../../schema/types/secret/entity";
import { linksOf } from "../../services/cpln";
import { parseLink } from "../../utils/linkParser/linkParser";

export const secretHelpers = {
  getTypePretty(secret: Secret) {
    switch (secret.type) {
      case "aws":
        return "AWS";
      case "azure-sdk":
        return "Azure SDK";
      case "azure-connector":
        return "Azure Connector";
      case "docker":
        return "Docker";
      case "dictionary":
        return "Dictionary";
      case "ecr":
        return "ECR";
      case "gcp":
        return "GCP";
      case "keypair":
        return "Keypair";
      case "nats-account":
        return "NATS Account";
      case "opaque":
        return "Opaque";
      case "tls":
        return "TLS";
      case "userpass":
        return "Username & Password";
      default:
        return "";
    }
  },
};

export interface SecretTableItem extends Secret {
  selfLink: string;
}

interface GetSecretTableItemProps {
  link?: string;
  name?: string;
  item?: Secret;
}
export function getSecretTableItem({ link, name, item }: GetSecretTableItemProps): SecretTableItem {
  if (item) {
    const selfLink = linksOf(item).self!;

    return {
      ...item,
      selfLink: selfLink,
    };
  }

  if (link) {
    const { name } = parseLink(link, { useInputCtx: true });

    return {
      kind: "secret",
      name: name,
      selfLink: link,
      links: [{ rel: "self", href: link }],
      created: "",
      description: "",
      id: "",
      data: "",
      type: "" as any,
      lastModified: "",
      tags: {},
      version: 1,
    };
  }

  // assume name
  return {
    kind: "secret",
    name: name!,
    selfLink: `TODO test if this breaks`,
    links: [],
    created: "",
    description: "",
    id: "",
    data: "",
    type: "" as any,
    lastModified: "",
    tags: {},
    version: 1,
  };
}

export const STORAGE_KEY_SECRET_LIST_HIDE_HELM_STATE = "STORAGE_KEY_SECRET_LIST_HIDE_HELM_STATE";
